import React, { useEffect, useState } from "react";
import { ThemeProvider } from "./ThemeContext";
import Layout from "./Layout/Layout";
import LoadingScreen from "./Layout/UI/WelcomeScreen/WelcomeScreen";

const Portfolio = () => {
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoader(true);
    }, 3000);
  }, []);

  return (
    <ThemeProvider>
      {loader ? <Layout /> : <LoadingScreen />}
    </ThemeProvider>
  );
};

export default Portfolio;
